import axios from "axios";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Header from "../../../common/Header";
import ScrollButton from "../../scrollButton";
import { MainWrapper } from "../../../common/MainWrapper";
import TodayDate from "../../../common/todayDate";
import moment from "moment/moment";
import {
  TableWrapper,
  ErrorMessage,
  StyledMainTitle,
} from "../../styled";
import {
  StyledParagraph,
} from "../../../common/LastDay/styled";
import { BackToArchPanel } from "../../../common/BackToArchPanel";
import { useArchResultStatment } from "../../../common/useArchResultStatment";
import { baseUrl } from "../../../common/apiUrl";

const ArchStatment = () => {
  const { id } = useParams();
  const [datesFromPHP, setDatesFromPHP] = useState({
    date_from: "",
    date_to: "",
    bonus_percentage: 0.0,
    extra_amount: 0.0,
  });

  const item = useArchResultStatment({ datesFromPHP });

  useEffect(() => {
    const fetchDatesPHP = async () => {
      try {
        const response = await axios.post(`${baseUrl}/archStatment.php?id=` + id);
        const datesFromPHP = response.data;

        setDatesFromPHP({
          date_from: datesFromPHP.date_from,
          date_to: datesFromPHP.date_to,
          bonus_percentage: datesFromPHP.bonus_percentage,
          extra_amount: datesFromPHP.extra_amount,
        });
      } catch (error) {
        console.error(error);
      }
    };
    fetchDatesPHP();
  }, [id]);

  let date_from = datesFromPHP.date_from;
  let date_to = datesFromPHP.date_to;
  let bonus_percentage = datesFromPHP.bonus_percentage;
  let extra_amount = datesFromPHP.extra_amount;

  let totalRegularHours = 0;
  let regularHoursRate = 0;
  let erningFromRegularHours = 0;

  let totalOperatorHours = 0;
  let operatorHoursRate = 0;
  let erningFromOperatorHours = 0;

  let totalOperatorHoursWeekend = 0;
  let operatorHoursWeekendRate = 0;
  let erningFromOperatorHoursWeekend = 0;

  let totalRegularHoursWeekend = 0;
  let regularHoursWeekendRate = 0;
  let erningFromRegularHoursWeekend = 0;

  let totalHours = 0;
  let totalErn = 0;
  let bonusAmount = 0.0;
  // let parsedExtraAmount = 0.00;
  let totalErnWithBonus = 0.0;

  const parsedExtraAmount = parseFloat(extra_amount);

  let FormattedData1 = moment(date_from).locale("en-gb").format("YYYY-MM-DD");
  let FormattedData2 = moment(date_to).locale("en-gb").format("YYYY-MM-DD");

  return (
    <>
      <Header />
      <ScrollButton />
      <MainWrapper>
        <StyledMainTitle>Statment </StyledMainTitle>

        <BackToArchPanel />
        {datesFromPHP.date_from && datesFromPHP.date_to ? (
                  <>
                    <p className="onlyPrint__header">
                      WTR - Working Time Records
                      <br />
                      <small>Radek Bubienko</small>
                    </p>
                    <p className="statment__from">
                      Statement from {date_from} to {date_to}
                    </p>
                    <TableWrapper>
                      <table className="table table-dark table-striped table-bordered table-modified">
                        <thead>
                          <tr>
                            <td>Date</td>
                            <td>Shift</td>
                            <td>
                              Hours
                              <br />
                              worked
                            </td>
                            <td>
                              Rate
                              <br />
                              per hour
                            </td>
                            <td>
                              Daily
                              <br />
                              earnings
                            </td>
                          </tr>
                        </thead>
                        <tbody>
                          {item.map((item) => {
                            let FormattedDataPracy = moment(item.data_pracy)
                              .locale("en-gb")
                              .format("YYYY-MM-DD - dddd");
        
                            let parseIlGodz = parseFloat(item.il_godzin);
        
                            if (
                      item.typ_stawki === "regular" &&
                      item.data_od === "2016-09-22"
                    ) {
                      totalRegularHours += parseIlGodz;
                      regularHoursRate = item.stawka;
                      erningFromRegularHours =
                        totalRegularHours * regularHoursRate;
                    }

                    if (
                      item.typ_stawki === "regular" &&
                      item.data_od === "2018-10-01"
                    ) {
                      totalRegularHours += parseIlGodz;
                      regularHoursRate = item.stawka;
                      erningFromRegularHours =
                        totalRegularHours * regularHoursRate;
                    }

                    if (
                      item.typ_stawki === "regular" &&
                      item.data_od === "2021-08-01"
                    ) {
                      totalRegularHours += parseIlGodz;
                      regularHoursRate = item.stawka;
                      erningFromRegularHours =
                        totalRegularHours * regularHoursRate;
                    }

                    if (
                      item.typ_stawki === "regular" &&
                      item.data_od === "2022-01-01"
                    ) {
                      totalRegularHours += parseIlGodz;
                      regularHoursRate = item.stawka;
                      erningFromRegularHours =
                        totalRegularHours * regularHoursRate;
                    }

                    if (
                      item.typ_stawki === "operator" &&
                      item.data_od === "2022-01-01"
                    ) {
                      totalOperatorHours += parseIlGodz;
                      operatorHoursRate = item.stawka;
                      erningFromOperatorHours =
                        totalOperatorHours * operatorHoursRate;
                    }

                    if (
                      item.typ_stawki === "operator weekend" &&
                      item.data_od === "2022-01-01"
                    ) {
                      totalOperatorHoursWeekend += parseIlGodz;
                      operatorHoursWeekendRate = item.stawka;
                      erningFromOperatorHoursWeekend =
                        totalOperatorHoursWeekend * operatorHoursWeekendRate;
                    }

                    if (item.typ_stawki === "regular weekend" &&
                      item.data_od === "2018-10-01"
                    ) {
                      totalRegularHoursWeekend += parseIlGodz;
                      regularHoursWeekendRate = item.stawka;
                      erningFromRegularHoursWeekend =
                        totalRegularHoursWeekend * regularHoursWeekendRate;
                    }

                    if (item.typ_stawki === "regular weekend" &&
                      item.data_od === "2021-08-01"
                    ) {
                      totalRegularHoursWeekend += parseIlGodz;
                      regularHoursWeekendRate = item.stawka;
                      erningFromRegularHoursWeekend =
                        totalRegularHoursWeekend * regularHoursWeekendRate;
                    }
        
                            totalHours =
                              totalRegularHours +
                              totalOperatorHours +
                              totalOperatorHoursWeekend +
                              totalRegularHoursWeekend;
        
                            totalErn =
                              erningFromRegularHours +
                              erningFromOperatorHours +
                              erningFromOperatorHoursWeekend +
                              erningFromRegularHoursWeekend;
                      
        
                            bonusAmount = (totalErn * bonus_percentage) / 100;
        
                            totalErnWithBonus =
                              bonusAmount + totalErn + parsedExtraAmount;
        
                            if (bonus_percentage === null && extra_amount === null) {
                              window.localStorage.setItem(
                                "totalErnNetto",
                                totalErn.toFixed(2)
                              );
                            } else {
                              window.localStorage.setItem(
                                "totalErnNetto",
                                totalErnWithBonus.toFixed(2)
                              );
                            }
        
                            return (
                              <tr key={item.id_daty}>
                                <td>{FormattedDataPracy}</td>
                                <td>{item.zmiana}</td>
                                <td>{item.il_godzin}</td>
                                <td>
                                  {item.typ_stawki} - {item.stawka} PLN
                                </td>
                                <td>{item.il_godzin * item.stawka} PLN</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </TableWrapper>
             
                    <StyledParagraph className="mb-2">
                      Please verify the hours for the period:
                      <br /> from {FormattedData1} to {FormattedData2}
                    </StyledParagraph>
                    {totalRegularHours > 0 ? (
                      <StyledParagraph>
                        Number of regular hours:
                        <br /> {totalRegularHours.toFixed(1)} h x{regularHoursRate} PLN
                        = {erningFromRegularHours.toFixed(2)} PLN.
                      </StyledParagraph>
                    ) : null}
                    
                    {totalOperatorHours > 0 ? (
                      <StyledParagraph>
                        Number of operator hours:
                        <br />
                        {totalOperatorHours.toFixed(1)}&nbsp;h x&nbsp;
                        {operatorHoursRate} PLN = {erningFromOperatorHours.toFixed(2)}{" "}
                        PLN.
                      </StyledParagraph>
                    ) : null}
                    
                    {totalOperatorHoursWeekend > 0 ? (
                      <StyledParagraph>
                        Number of weekend operator hours:
                        <br />
                        {totalOperatorHoursWeekend.toFixed(1)} h x&nbsp;
                        {operatorHoursWeekendRate} PLN =&nbsp;
                        {erningFromOperatorHoursWeekend.toFixed(2)} PLN.
                      </StyledParagraph>
                    ) : null}
                    
                    {totalRegularHoursWeekend > 0 ? (
                      <StyledParagraph>
                        Number of weekend regular hours:
                        <br />
                        {totalRegularHoursWeekend.toFixed(1)} h x{" "}
                        {regularHoursWeekendRate}
                        &nbsp; PLN = {erningFromRegularHoursWeekend.toFixed(2)} PLN.
                      </StyledParagraph>
                    ) : null}
                    
                    
                    {totalHours > 0 ? (
                      <StyledParagraph>
                        <br />
                        Total number of hours: {totalHours.toFixed(1)} h.
                      </StyledParagraph>
                    ) : null}
                    {totalErn > 0 ? (
                      <StyledParagraph>
                        Total to pay: {totalErn.toFixed(2)} PLN/netto.
                      </StyledParagraph>
                    ) : null}
                    {bonus_percentage > 0 ? (
                      <StyledParagraph>
                        Bonus {bonus_percentage} % = {bonusAmount.toFixed(2)} PLN/netto.
                      </StyledParagraph>
                    ) : null}
                    {extra_amount > 0 ? (
                      <StyledParagraph>
                        Extra amount:
                        <b>{parsedExtraAmount.toFixed(2)}</b> PLN/netto.
                        <br />
                      </StyledParagraph>
                    ) : null}
                    {bonus_percentage > 0 || extra_amount > 0 ? (
                      <StyledParagraph>
                        Total to pay with bonuses: {totalErnWithBonus.toFixed(2)}{" "}
                        PLN/netto.
                      </StyledParagraph>
                    ) : null}
                  </>
                ) : (
                  <ErrorMessage>Coś poszło nie tak! Spróbój jeszcze raz.</ErrorMessage>
                )}

        {totalErn > 0 ? (
          <>
            <div className="container-fluid d-print-none">
              <div className="row justify-content-center">
                <button
                  className="btn btn-primary btn-lg mt-3 m-2 col-md-2"
                  onClick={() => window.print()}
                >
                  Print
                </button>

              </div>
            </div>
          </>
        ) : null}

        <div className="text-white mt-3">
          <TodayDate />
        </div>
      </MainWrapper>
    </>
  );
};

export default ArchStatment;
